<template>
  <div id="app" :class="$i18n.locale === 'en' ? 'font-en' : ''">
    <Header></Header>
    <router-view class="middle-11" />
    <Footer></Footer>
    <GoTop></GoTop>
  </div>
</template>

<script>
export default {
  name: 'App',
  created() {
    const lang = localStorage.getItem('lang')
    if(lang === 'zh') {
      document.title = '派特美生'
    } else {
      document.title = 'Pet Medtech'
    }
  }
}
</script>

<style>
  @font-face {
    font-family: 'OPENSANS';
    src: url("./assets/fonts/OpenSans.ttf") format("truetype");
  }
  html {
    overflow-x: hidden;
  }
  .font-en {
    font: 12px OPENSANS, "Helvetica Neue", Arial, "Microsoft YaHei", "微软雅黑", "PingFang SC", sans-serif;
  }
  body {
    font: 12px "Microsoft YaHei", "微软雅黑", "PingFang SC", "Helvetica Neue", Arial, sans-serif;
    overflow-x: hidden;
  }
  /* 鼠标点击不显示焦点轮廓 */
  a:focus,
  button:focus,
  [role="button"]:focus {
    outline: none;
  }
  /* 键盘 Tab 时仍显示焦点(保留无障碍可访问性) */
  a:focus-visible,
  button:focus-visible,
  [role="button"]:focus-visible {
    outline: 2px solid #093a92;
    outline-offset: 2px;
    border-radius: 2px;
  }
  @media screen and (max-width: 768px) {
    .middle-11 {
      margin-top: 80px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue